/**
 * DataTableBlock — the data contract for interactive table components.
 *
 * This is a pure TypeScript file with zero framework imports.
 * Backend tool schemas (Zod) should mirror these types.
 */

export interface DataTableColumn {
  key: string;
  label: string;
  type?: 'text' | 'number' | 'currency' | 'date' | 'percent' | 'status' | 'link';
  sortable?: boolean;
  align?: 'left' | 'right' | 'center';
  status_colors?: Record<string, string>;
}

export interface DataTableDeepLink {
  /** Which column to make clickable (e.g., "deal_name") */
  column: string;
  /** Entity type (e.g., "deal") */
  entity: string;
  /** URL pattern with {id} placeholder (e.g., "/crm/deals/{id}") */
  pattern: string;
  /** Row field containing the entity ID (e.g., "deal_id") */
  id_field: string;
}

export interface DataTableBlock {
  title: string;
  columns: DataTableColumn[];
  rows: Array<Record<string, unknown>>;
  deep_links?: DataTableDeepLink[];
  total_count?: number;
  truncated?: boolean;
  sql?: string;
}

export function isValidDataTableBlock(data: unknown): data is DataTableBlock {
  if (!data || typeof data !== 'object') return false;
  const d = data as Record<string, unknown>;
  return (
    typeof d.title === 'string' &&
    Array.isArray(d.columns) &&
    d.columns.length > 0 &&
    Array.isArray(d.rows)
  );
}
